import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import VueCookie from 'vue-cookie';

import userAuthStore from '@/store/userAuthStore';
import login from '@/components/login';
import portal from '@/components/portal';

// Portal components
import myDashboard from '@/components/portal/dashboard';
import myPersonalInfo from '@/components/portal/personal-info';
import myReservations from '@/components/portal/reservations';
import contact from '@/components/portal/contact';

// reservation Components
import reservationsUpcoming from '@/components/reservations/upcoming';
import reservationsArchive from '@/components/reservations/archive';
import reservation from '@/components/reservations/reservation';
import invoice from '@/components/reservations/invoice';
import travelPackage from '@/components/reservations/travel-package';
import documents from '@/components/reservations/documents';
import participants from '@/components/reservations/participants';
import insurances from '@/components/reservations/insurances';
import passengers from '@/components/reservations/passengers';
import preferences from '@/components/reservations/preferences';

Vue.use(Router);
Vue.use(Meta);
Vue.use(VueCookie);

const router = new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: '/login',
      meta: { auth: false },
    }, {
      path: '/login',
      component: login,
      meta: { auth: false },
    }, {
      path: '/my',
      redirect: '/my-dashboard',
      component: portal,
      meta: { auth: true },
      children: [
        {
          path: '/my-dashboard',
          component: myDashboard,
          meta: { auth: true },
        }, {
          path: '/my-personal-info',
          component: myPersonalInfo,
          meta: { auth: true },
        }, {
          path: '/contact',
          component: contact,
          meta: { auth: true },
        }, {
          path: '/my-reservations',
          redirect: '/my-reservations/upcoming',
          component: myReservations,
          meta: { auth: true },
          children: [
            {
              path: 'upcoming',
              component: reservationsUpcoming,
              meta: { auth: true },
            }, {
              path: 'archive',
              component: reservationsArchive,
              meta: { auth: true },
            },
          ],
        }, {
          path: '/my-reservation/:reservationId',
          name: 'reservation',
          redirect: { name: 'res-travel-package' },
          component: reservation,
          props: true,
          meta: { auth: true },
          children: [
            {
              path: 'travel-package',
              component: travelPackage,
              name: 'res-travel-package',
              props: true,
              meta: { auth: true },
            }, {
              path: 'invoice',
              component: invoice,
              name: 'res-invoice',
              props: true,
              meta: { auth: true },
            }, {
              path: 'documents',
              component: documents,
              name: 'res-docs',
              props: true,
              meta: { auth: true },
            }, {
              path: 'participants',
              component: participants,
              name: 'res-participants',
              props: true,
              meta: { auth: true },
            }, {
              path: 'insurances',
              component: insurances,
              name: 'res-insurances',
              props: true,
              meta: { auth: true },
            }, {
              path: 'passengers',
              component: passengers,
              name: 'res-passengers',
              props: true,
              meta: { auth: true },
            }, {
              path: 'preferences',
              component: preferences,
              name: 'res-preferences',
              props: true,
              meta: { auth: true },
            },
          ],
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    if (!userAuthStore.state.loggedIn) {
      next({ path: '/login' });
    }
  }
  next();

});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js